// Service
import breedingManagementService from "@/app/services/main/breeding-management/breeding-management-service.js";

// Mixins
import { comingSoonMixins } from "@/app/mixins/utils/coming-soon-mixins"
import { tableMixins } from "@/app/mixins/utils/table-mixins"
// Constants
import { STATUS_CODES } from "@/app/constants/status-constants"
import { BREEDER_ROUTES } from '@/app/constants/breeder-routes-constants';

export default {
    name: 'PuppyManagementList',
    components: {},
    directive: {},
    filters: {},
    mixins: [
        tableMixins,
        comingSoonMixins,
    ],
    props: {},
    data() {
        return {
            isAPILoading: false,
            // table
            theads: [
                {
                    name: "Mating Name",
					searchLabel: "f_matingName",
					sortLabel: "matingName",
					hasSearch: true,
					isDesc: false,
					style: "min-width: 185px;"
                },
                {
                    name: "Litter Count",
                    searchLabel: "f_totalLitters",
					sortLabel: "totalLitters",
					hasSearch: true,
					isDesc: false,
					style: "min-width: 185px;"
                },
                { name: null, searchLabel: null, sortLabel: null, isDesc: false, style: "width: 170px" },
            ],
            // pagination
			page: 1,
			pageCount: 0,
			totalCount: 0,
            limit: 10,
			// sorting
			sortBy: '',
			desc: true,
			columnsFilter: {},
            matingData: {},
            tableContent: {
                tableData: [],
                paginationData: {},
            },
        }
    },
    computed: {},
    watch: {},
    created() {
        this.getTableContent()
    },
    methods: {
        getTableContent(
			page = this.page,
			limit = this.limit,
			sortBy = this.sortBy,
			desc = this.desc,
			fromFilter = false
		) {
			page = fromFilter ? 1 : this.page
			this.getPuppyManagementList({ page, limit, sortBy, desc })
		},

        getPuppyManagementList(queryParams) {
            this.isAPILoading = true
            if (this.columnsFilter) {
                if (this.columnsFilter.f_matingName) {
                    queryParams["f_matingName"] = this.columnsFilter.f_matingName
                }
                if (this.columnsFilter.f_totalLitters) {
                    queryParams["f_totalLitters"] = this.columnsFilter.f_totalLitters
                }
            }

            breedingManagementService
                .getPuppyManagementList(queryParams)
                .then((response) => {
                    if (response.status === STATUS_CODES.SUCCESS) {
                        this.tableContent = {
                            tableData: response.data.data,
                            paginationData: response.data.pagination
                        }
                    }
                    this.isAPILoading = false
                })
                .catch((error) => {
                    this.$toast.error(error)
                })
                .finally(() => {
                    this.isAPILoading = false
                })
        },

        gotoPuppyManagementDetails(id){
            this.$router.push(`${BREEDER_ROUTES.LITTER_LIST}?id=${id}&from=litter-management`)

        },
    },
    // third party libraries
}